import { Injectable } from '@angular/core';
import { CentralService } from './central.service';
import { HttpClient } from '@angular/common/http';
import { CryptoService } from './crypto.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TicketService extends CentralService {
  protected resource = "ticket"; // Define API endpoint for tickets

  constructor(http: HttpClient, cryptoService: CryptoService) {
    super(http, cryptoService); // Pass dependencies to CentralService
  }

  // Function to send a message to a specific ticket
  sendMessage(ticketId: number, message: string): Observable<any> {
    return this.postSpecific(ticketId, { message });
  }
}
